/**
 * Tiny registry bridging the timesheet views and the export modal.
 *
 * Each view (monthly / yearly) lives inside its own context provider, while
 * the "Export Attendance" button sits outside them in the page container —
 * so the views publish their current filters here and the modal reads them
 * when it opens, pre-filling period/year/month/email/branch to match what
 * the user is looking at. Pagination is intentionally NOT tracked: exports
 * always fetch every page.
 */
const registry = {};

export const setTimesheetExportContext = (view, params) => {
    registry[view] = params;
};

export const getTimesheetExportContext = (view) => registry[view] || null;
